import {
  ApplySchemaAttributes,
  MarkExtension,
  MarkExtensionSpec,
  MarkSpecOverride,
  extension,
} from 'remirror';

export interface LoudnessMarkOptions {
  className?: string;
}

const defaultOptions: Required<LoudnessMarkOptions> = {
  className: 'loudness-mark',
};

@extension<LoudnessMarkOptions>({
  defaultOptions,
  staticKeys: [],
  handlerKeys: [],
  customHandlerKeys: [],
})
export class LoudnessMark extends MarkExtension<LoudnessMarkOptions> {
  get name() {
    return 'loudness' as const;
  }

  createMarkSpec(
    extra: ApplySchemaAttributes,
    override: MarkSpecOverride
  ): MarkExtensionSpec {
    return {
      ...override,
      inclusive: false,
      excludes: 'loudness',
      attrs: {
        ...extra.defaults(),
        value: { default: '' },
      },
      parseDOM: [
        {
          tag: 'loudness',
          getAttrs: (dom: Node | string) => {
            const el = dom as Element;
            return {
              ...extra.parse(dom),
              value: el.getAttribute('value') ?? '',
            };
          },
        },
        ...(override.parseDOM ?? []),
      ],
      toDOM: node => {
        const attrs: Record<string, string | number | undefined> = {
          ...extra.dom(node),
          class: this.options.className,
          value: node.attrs.value,
        };
        return ['loudness', attrs, 0];
      },
    };
  }
}

export default LoudnessMark;
